<template>
  <div id="app">
    <router-view></router-view>
    <FloatButton v-if="showExchangeEnv" />
  </div>
</template>

<script>
import FloatButton from "@/components/FloatButton/index.vue";

export default {
  name: "App",
  components: { FloatButton },
  computed: {
    showExchangeEnv() {
      return process.env.NODE_ENV !== "production";
    },
  },
  mounted() {
    if (typeof window !== "undefined" && window._VMA === undefined) {
      window._this = this;
    }
  },
};
</script>

<style>
@import "./style/style.css";
@import url("./assets/css/common.css");

body {
  margin: 0;
  padding: 0;
}

.status {
  display: inline-block;
  color: #666;
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-decoration: none;
  cursor: pointer;
}

.status.active {
  background: #409eff;
  color: #fff;
}

#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}

/* 提示内容如果超出了屏幕宽度，自动换行 */
.el-message--error .el-message__content {
  word-break: break-all;
}

/* 解决表格宽度计算bug */
.el-table {
  width: 99.9% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue